import { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { fetchResults } from "../../slices/searchThunks";

const useSearchResults = (queryKeyword, coordinates) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const previousQuery = useRef({ queryKeyword: null, coordinates: null });

  useEffect(() => {
    console.log("🔍 useSearchResults triggered with:", { queryKeyword, coordinates });

    if (!queryKeyword || !coordinates) {
      console.warn("⚠️ Missing queryKeyword or coordinates. Skipping fetch.");
      return;
    }

    if (
      previousQuery.current.queryKeyword === queryKeyword &&
      previousQuery.current.coordinates?.[0] === coordinates?.[0] &&
      previousQuery.current.coordinates?.[1] === coordinates?.[1]
    ) {
      console.log("🚫 Duplicate query detected. Skipping fetch.");
      return;
    }

    previousQuery.current = { queryKeyword, coordinates };

    const fetchData = async () => {
      setLoading(true);
      setError(null);

      console.log(`🚀 Fetching results for: "${queryKeyword}" at coordinates:`, coordinates);

      try {
        const results = await dispatch(fetchResults(queryKeyword, coordinates));
        console.log("✅ API Response Data:", results);
        setData(results);
      } catch (err) {
        console.error("❌ Error fetching search results:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [queryKeyword, coordinates, dispatch]);

  return { data, loading, error };
};

export default useSearchResults;
